import React from 'react'
import {
  Button,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  SelectCheckbox,
  TagAdder,
  ButtonOutline,
  // FormDashboardInputNumber as InputNumber,
  // Checkbox,
} from '../../../components'
import { useHistory } from 'react-router-dom'
import { MobileViewportProvider } from '../../../utils'
// import { FileUploader } from './file-uploader'
// import { SidebarPartner } from './sidebar-partner'
// import { SidebarOfficer } from './sidebar-officer'
import { RejectionPopup } from './rejection-popup'

const Sidebar = () => {
  const history = useHistory()
  const [rejectionPopedUp, setRejectionPopedUp] = React.useState(false);

  return (
    <div>
      <div className="hidden lg:block p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
        <p className="text-sm text-gray-444">Status: <strong>Rejected</strong></p>
        <p className="link mb-3" onClick={() => setRejectionPopedUp(true)}>Apa yang harus diperbaiki?</p>
        {
          rejectionPopedUp &&
          <RejectionPopup onClose={setRejectionPopedUp}/>
        }
        <p className="text-sm text-gray-444 mb-5">Status Inisiatif: <strong style={{color: '#FF5448'}}>Ongoing</strong></p>
        <Button className="mb-3" onClick={() => history.push('/dashboard/programs')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent py-4 border"
          onClick={() => history.push('/dashboard/programs')}
        >
          Save to Draft
        </ButtonOutline>
      </div>
      <div className="mb-5 lg:mb-10">
        <ImagePickerSidebar label="Thumbnail Image"/>
      </div>
      {/* <div className="mb-5 lg:mb-10">
        <SidebarPartner />
      </div> */}
      {/* <div className="mb-5 lg:mb-10">
        <SidebarOfficer />
      </div> */}
      <div className="mb-5 lg:mb-10">
        <Label>Suitable For</Label>
        <SelectCheckbox className="text-sm" placeholder="Choose"/>
      </div>
      {/* <div className="mb-5 lg:mb-10">
        <Label>Upload final report</Label>
        <FileUploader />
      </div> */}
      <div className="mb-5 lg:mb-10">
        <Label>Tag</Label>
        <TagAdder />
      </div>
      {/* <div className="mb-12">
        <Label>Total Beneficiaries</Label>
        <div className="flex justify-between items-center mb-2 pt-3">
          <p className="w-1/2 text-sm text-gray-444">Men</p>
          <InputNumber className="w-1/2"/>
        </div>
        <div className="flex justify-between items-center">
          <p className="w-1/2 text-sm text-gray-444">Women</p>
          <InputNumber className="w-1/2"/>
        </div>
      </div> */}
      {/* <div className="mb-8 lg:mb-10">
        <Label>Milestones</Label>
        <div className="pt-3">
          <Checkbox className="mb-2" id="checkbox1" label="Amet minim mollit non deserunt ullamco est sit" defaultChecked={true}/>
          <Checkbox className="mb-2" id="checkbox2" label="Mollit non deserunt ullamco est"/>
          <Checkbox className="mb-3" id="checkbox3" label="Minim mollit non deserunt ullamco est sit"/>
          <p className="underline pl-8 lg:pl-5 cursor-pointer text-sm text-primary">+ Add New Milestones</p>
        </div>
      </div> */}

      <MobileViewportProvider>
        <Button className="mb-8" thin onClick={() => history.push('/dashboard/programs')}>Publish</Button>
      </MobileViewportProvider>
    </div>
  )
}

export { Sidebar }
